import { type FC, memo } from 'react';
import { Flex } from '@eqi-investimentos/react';
import { Icon } from '@/components/elements/Icon';

const PlayerError: FC<PlayerErrorProps> = ({ error }) => {
  const refreshHandler = () => window.location.reload();

  if (!error) {
    return <></>;
  }

  return (
    <Flex
      pos="absolute"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      gap="8"
      w="full"
      h="full"
      fontSize="1.5em"
      fontWeight="semibold"
      color="#cd131c"
      bgColor="rgba(0, 0, 0, 0.8)"
      zIndex="100"
      sx={{
        svg: {
          w: 20,
          h: 20,
          cursor: 'pointer',
        },
      }}
    >
      <p>
        {error.code ? `${error.code}: ` : ''}
        {error.message || 'Error occurred! Please try again'}
      </p>
      <Icon iconName="Refresh" onClick={refreshHandler} />
    </Flex>
  );
};

export default memo(PlayerError);

type PlayerErrorProps = {
  error: MediaError | null;
};
